import AppHeader from '../../components/AppHeader';
import Loader from '../../components/Loader';
import NoData from '../../components/NoData';
import Sidebar from '../../components/Sidebar';
import Transitions from '../../components/Transition';
import useGetGeneralAppData from '../../hooks/useGetGeneralAppData';
import ChangeStatusModal from './components/ChangeStatusModal';
import Filters from './components/Filters';
import ListHeader from './components/Header';
import ImportModal from './components/ImportModa';
import List from './components/list';
import useWorkplaces from './useWorkplaces';

export default function Workplaces() {
  const {
    isLoading,
    workplaces,
    workplaceCode,
    handleWorkplaceCodeChange,
    streetName,
    handleStreetNameChange,
    handleStatusChange,
    selectedStatus,
    workplaceName,
    handleWorkplaceNameChange,
    hasError,
    filteredWorkplaces,
    pagesQuantity,
    currentPage,
    handlePageChange,
    downloadExcel,
    setImportModalShow,
    handleOpenChangeStatusModal,
    apiFetched,
    handleTryAgain,
    workplaceChanginStatus,
    setChangeStatusModalShow,
    updateWorkplaceStatus,
    changeStatusModalShow,
    importModalShow,
    csvFileName,
    handleFileUpload,
    handleSubmitFile,
  } = useWorkplaces();

  const { companyCode } = useGetGeneralAppData();
  const isCompanySelected = !!companyCode;
  const hasWorkplaces = workplaces?.length !== 0 && !!workplaces && !isLoading;
  const filteredListLength = filteredWorkplaces?.length ?? 0;
  const anyResultsByFilterSelection = !filteredWorkplaces?.length && !isLoading && !hasError && workplaces?.length !== 0;
  const isListEmpty = !hasError && (!isLoading && workplaces?.length === 0);

  return (
    <>
      <AppHeader isCompanySelectedDisabled={false} />
      <Sidebar active="Workplaces" />
      <Transitions>
        <Loader isLoading={isLoading} />

        {isCompanySelected && (
          <>
            {hasWorkplaces && (
              <Filters
                workplaceCode={workplaceCode}
                handleWorkplaceCodeChange={handleWorkplaceCodeChange}
                streetName={streetName}
                handleStreetNameChange={handleStreetNameChange}
                handleStatusChange={handleStatusChange}
                selectedStatus={selectedStatus}
                workplaceName={workplaceName}
                handleWorkplaceNameChange={handleWorkplaceNameChange}
              />
            )}

            <ListHeader
              doesListExists={hasWorkplaces}
              hasError={hasError}
              filteredListLength={filteredListLength}
              singularLabel="Local de trabalho"
              pluralLabel="Locais de trabalho"
              pagesQuantity={pagesQuantity}
              currentPage={currentPage}
              onPageChange={handlePageChange}
              downloadExcel={downloadExcel}
              filePathDownload="/files/Modelo importar locais de trabalho.csv"
              setImportModalShow={setImportModalShow}
            />

            {hasWorkplaces && (
              <List
                filteredList={filteredWorkplaces}
                handleOpenChangeStatusModal={handleOpenChangeStatusModal}
              />
            )}

            <ChangeStatusModal
              workplaceChanginStatus={workplaceChanginStatus}
              setChangeStatusModalShow={setChangeStatusModalShow}
              updateWorkplaceStatus={updateWorkplaceStatus}
              changeStatusModalShow={changeStatusModalShow}
            />

            <ImportModal
              importModalShow={importModalShow}
              csvFileName={csvFileName}
              handleFileUpload={handleFileUpload}
              handleSubmitFile={handleSubmitFile}
              setImportModalShow={setImportModalShow}
            />

            {anyResultsByFilterSelection && (
              <NoData
                icon="searchNotFound"
                label={(
                  <>
                Não encontramos nenhum resultado.
                Por favor, tente alterar os filtros.
                  </>
                )}
              />
            )}

            {!apiFetched && !isLoading && (
              <NoData
                icon="sad"
                label={(
                  <>
                Ocorreu um erro ao obter a lista dos locais de trabalho.
                    <button type="button" onClick={handleTryAgain}>Tentar Novamente</button>
                .
                  </>
                )}
              />
            )}

            {isListEmpty && (
              <NoData
                icon="emptyBox"
                label={(
                  <>
                Não há nenhum local de trabalho cadastrado, clique no botão
                    {' '}
                    <strong>Novo local de trabalho</strong>
                    {' '}
                acima para cadastrar seu primeiro!
                  </>
                )}
              />
            )}
          </>
        )}

        {!isCompanySelected && (
          <NoData
            icon="companyInterrogation"
            label={(
              <>
              Selecione uma empresa para visualizar os seus locais de trabalho.
              </>
            )}
          />
        )}

      </Transitions>
    </>
  );
}
